import { useDecimalPlaces } from "$root/functional-areas/user/useDecimalPlaces";
import { FormField, Label, StepperInput } from "@mdotm/shadcn/mdotm/components";

function DecimalsLabel({ htmlFor }: { htmlFor: string }) {
	return (
		<Label htmlFor={htmlFor} className="mb-px">
			Decimals
		</Label>
	);
}

/**
 * How many decimals the weight columns are rounded to. The preference is the user's own and is
 * written back on every change, so the control takes no value from the editor.
 */
export function DecimalsStepper(): React.JSX.Element {
	const { userDecimalPlacesPreferences, customerDecimalPlacesPreferences, handlePrecisionChange } = useDecimalPlaces();

	return (
		<FormField label={DecimalsLabel}>
			{(fieldProps) => (
				<StepperInput
					{...fieldProps}
					size="x-small"
					value={userDecimalPlacesPreferences ?? null}
					onChange={handlePrecisionChange}
					max={customerDecimalPlacesPreferences}
					min={2}
				/>
			)}
		</FormField>
	);
}
